import React, { Children, ReactNode } from 'react'
import Paragraph from '../../../scentregroup-ui/components/paragraph'
import FormHeader from '../form-header'
import style from './index.scss'

interface Props {
  title: string
  form: ReactNode
  toggleLoginSignup?: ReactNode
  intro?: ReactNode
  outro?: ReactNode
  socialLogins?: ReactNode
  footer?: ReactNode
}

const OnboardingForm: React.FC<Props> = (props) => (
  <>
    <FormHeader title={props.title} />
    {props.toggleLoginSignup}

    {Children.map(props.intro, (child) => (
      <Paragraph className={style.intro}>{child}</Paragraph>
    ))}

    <div className={style.form}>{props.form}</div>
    {props.outro}
    {props.socialLogins}
    {props.footer}
  </>
)

export default OnboardingForm
